'use client'

import { createContext, useContext, ReactNode } from 'react'
import { useTaskToolDialogStore } from '@/features/task-tool-part-chat-bot/model/store'

interface TaskToolContextValue {
  projectId: string
  taskId: string
  toolId: string
  readonly?: boolean
  closeDialog?: () => void
}

const TaskToolContext = createContext<TaskToolContextValue | null>(null)

export const useTaskToolContext = () => {
  const context = useContext(TaskToolContext)
  return context
}

interface TaskToolContextProviderProps {
  children: ReactNode
  projectId: string
  taskId: string
  toolId: string
  readonly?: boolean
  closeDialog?: () => void
}

export const TaskToolContextProvider = ({
  children,
  projectId,
  taskId,
  toolId,
  readonly = false,
  closeDialog,
}: TaskToolContextProviderProps) => {
  const store = useTaskToolDialogStore()

  const handleCloseDialog = () => {
    if (store.refetchBoard) {
      store.refetchBoard()
    }

    if (closeDialog) {
      closeDialog()
    }
  }

  return (
    <TaskToolContext.Provider value={{ projectId, taskId, toolId, readonly, closeDialog: handleCloseDialog }}>
      {children}
    </TaskToolContext.Provider>
  )
}
